import { render, staticRenderFns } from "./afterSaleList.vue?vue&type=template&id=3a1bad19&scoped=true&"
import script from "./afterSaleList.vue?vue&type=script&lang=js&"
export * from "./afterSaleList.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleList.vue?vue&type=style&index=0&id=3a1bad19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1bad19",
  null
  
)

export default component.exports